import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { currency } from 'app/constants/currency.constants';

import { HelperService, HTTPService, FormatService, DataService } from 'app/services';
import { find } from 'lodash';

@Component({
  selector: 'app-tire-add-to-cart-dialog',
  templateUrl: './tire-add-to-cart-dialog.component.html',
  styleUrls: ['./tire-add-to-cart-dialog.component.scss'],
  providers: [DialogService],
})
export class TireAddToCartDialogComponent implements OnInit {
  isAdding: boolean = false;
  selectedSupplier: string = '';
  tire: any = {};
  seasonLabel = {
    '': 'All season',
    summer: 'Summer',
    winter: 'Winter',
    all: 'All season',
  };
  tireSupplierDetails: any = [];
  isLoading: boolean = false;
  isSaveDisabled: boolean = false;
  locations: any = [];
  source: any = '';
  selectedQty: number = 0;
  isQTQAddOnEnable: boolean = this.dataService.isQTQAddOnEnable;
  remainingQty: number = 0;
  isOpenFromReplenishment: boolean = false;

  availableQtyOptions: any[] = [];
  usd: string = currency.USD;
  fetValueSource: string = '';
  isRunTireStorageFlow: boolean = false;

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private helperService: HelperService,
    private formatService: FormatService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    const { tireDetails, source, isOpenFromReplenishment, isRunTireStorageFlow } = this.dynamicDialogConfig.data;
    this.isOpenFromReplenishment = isOpenFromReplenishment;
    this.isRunTireStorageFlow = isRunTireStorageFlow;

    if (this.isOpenFromReplenishment) {
      this.isQTQAddOnEnable = false;
    }

    this.source = source;
    this.tire = tireDetails;
    //this.selectedQty = selectedQty;
    this.remainingQty = this.selectedQty;

    if (source === 'tireconnect' && this.tire?.numericItemId) {
      this.getCartTireDetails(this.tire.numericItemId);
    } else if (source === 'tirehub') {
      this.getTireHubDetailsByPartNumber();
      this.locations = this.helperService.deepCopy(tireDetails?.locations) || [];

      const warehouses: any = this.helperService.deepCopy(tireDetails?.warehouses) || {};

      Object.values(warehouses).forEach(({ warehouseId, count }: any) => {
        this.locations.forEach((location: any) => {
          if (warehouses[location?.warehouseId]) {
            location.count = warehouses[location?.warehouseId]?.count;
          }
        });
      });

      if (this.isQTQAddOnEnable && this.locations?.length) {
        this.setTireHubGlobalSelectedQty();
      }

      if (this.isQTQAddOnEnable) {
        if (tireDetails?.localLocations?.length) {
          this.availableQtyOptions.push({
            name: 'Local',
            addedQty: 0,
            TotalQty: this.getTotalAvailableCount(tireDetails.localLocations),
            cost: tireDetails?.localCost || 0,
            locations: this.helperService.deepCopy(tireDetails.localLocations),
          });
        }

        if (tireDetails?.otherLocations?.length) {
          this.availableQtyOptions.push({
            name: 'Other',
            addedQty: 0,
            TotalQty: this.getTotalAvailableCount(tireDetails.otherLocations),
            cost: tireDetails?.otherCost || 0,
            locations: this.helperService.deepCopy(tireDetails.otherLocations),
          });
        }

        this.availableQtyOptions.push({
          name: 'Online',
          addedQty: 0,
          TotalQty: tireDetails?.countAvailable || 0,
          cost: tireDetails?.cost || 0,
          locations: this.locations || [],
        });
      }
    }
  }

  getTireHubDetailsByPartNumber() {
    let partNumber: string = this.tire?.numericItemId;
    if (!partNumber) {
      return;
    }
    const dataObj = {
      partNumbers: [partNumber],
      season: null,
      categories: [],
      suppliers: [],
      offers: [],
    };
    this.isLoading = true;
    this.httpService
      .getFETFromTireConnect(dataObj)
      .then(
        (res: any) => {
          if (res?.data?.tires?.length) {
            if (!this.tire?.fetValue) {
              this.tire.tireconnectFetValue = res?.data?.tires[0].fet || 0;
              this.tire.tireconnectFetSource = res?.data?.tires[0]?.fet_source || '';
              if (this.tire?.tireconnectFetValue) {
                this.tire.fetValue = this.tire?.tireconnectFetValue;
                this.fetValueSource = 'tireconnect';
              }
            }

            this.tire.category = res?.data?.tires[0]?.category || '';
            this.tire.tireType = res?.data?.tires[0]?.tire_type || '';
          } else {
            //this.helperService.showToaster('error', res?.notice);
          }
        },
        (err) => {
          //this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  getTotalAvailableCount(localOtherTires: any[]) {
    let totalCount: number = 0;
    if (localOtherTires?.length) {
      localOtherTires.forEach((tire: any) => {
        totalCount += tire.totalAvailable;
      });
    }
    return totalCount;
  }

  setTireConnectSelectedQty() {
    this.tireSupplierDetails.forEach((supplier: any) => {
      supplier.locations.forEach((location: any) => {
        if (this.remainingQty > 0) {
          if (location.totalAvailable > this.remainingQty) {
            location.count = this.remainingQty;
            this.remainingQty = 0;
          } else {
            this.remainingQty = this.remainingQty - location.totalAvailable;
            location.count = location.totalAvailable;
          }
        }
      });
    });
  }

  setTireHubGlobalSelectedQty() {
    this.locations.forEach((location: any) => {
      if (this.remainingQty > 0) {
        if (location.totalAvailable > this.remainingQty) {
          location.count = this.remainingQty;
          this.remainingQty = 0;
        } else {
          this.remainingQty = this.remainingQty - location.totalAvailable;
          location.count = location.totalAvailable;
        }
      }
    });
  }

  getCartTireDetails(tireId: string) {
    this.isLoading = true;
    this.httpService
      .getTireConnectCartDetails(tireId)
      .then(
        (data: any) => {
          if (data && data.tire && data.tire.length) {
            this.tireSupplierDetails = this.formatService.formatTireConnectData(data, tireId);

            if (this.tireSupplierDetails?.length) {
              this.selectedSupplier = this.tireSupplierDetails[0].labelName;
            }

            if (this.isQTQAddOnEnable) {
              if (this.tire?.localLocations?.length) {
                this.availableQtyOptions.push({
                  name: 'Local',
                  addedQty: 0,
                  TotalQty: this.getTotalAvailableCount(this.tire?.localLocations),
                  cost: this.tire?.localCost || 0,
                  locations: this.tire.localLocations,
                });
              }

              if (this.tire?.otherLocations?.length) {
                this.availableQtyOptions.push({
                  name: 'Other',
                  addedQty: 0,
                  TotalQty: this.getTotalAvailableCount(this.tire?.otherLocations),
                  cost: this.tire?.otherCost || 0,
                  locations: this.tire.otherLocations,
                });
              }

              this.availableQtyOptions.push({
                name: 'Online',
                addedQty: 0,
                TotalQty: this.tire?.countAvailable || 0,
                cost: this.tire?.cost || 0,
                locations: this.tireSupplierDetails || [],
              });
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
        if (this.isQTQAddOnEnable && this.tireSupplierDetails?.length) {
          this.setTireConnectSelectedQty();
        }
      });
  }

  handleSupplierChange(event: any) {
    this.selectedSupplier = event;
  }

  handleFocus(location: any) {
    location.error = false;
  }

  handleBlur(location: any) {
    if (location.totalAvailable < location.count) {
      location.error = true;
      this.helperService.showToaster('error', `Qty can't be greater than available qty`);
    }
    if (this.source === 'tireconnect') {
      this.handleValidate();
    } else if (this.source === 'tirehub') {
      this.handleValidateTireHub();
    }
  }

  handleCountChange(location: any, count: number) {
    location.count = Number(count || 0);
  }

  handleTotalAddedTireConnect(availableQtyObj: any) {
    availableQtyObj.addedQty = 0;
    if (availableQtyObj.name === 'Online') {
      if (availableQtyObj?.locations?.length) {
        availableQtyObj?.locations.forEach((loc: any) => {
          if (loc?.locations?.length) {
            loc.locations.forEach((locations: any) => {
              availableQtyObj.addedQty += locations.count;
            });
          }
        });
      }
    } else {
      this.handleTotalAddedCount(availableQtyObj);
    }
    return availableQtyObj.addedQty;
  }

  handleTotalAddedCount(availableQtyObj: any) {
    availableQtyObj.addedQty = 0;
    if (availableQtyObj?.locations?.length) {
      availableQtyObj?.locations.forEach((loc: any) => {
        availableQtyObj.addedQty += loc.count;
      });
    }
    return availableQtyObj.addedQty;
  }

  handleValidateQTQ() {
    this.isSaveDisabled = false;
    const availableAddedOptions: any[] = this.availableQtyOptions?.filter((option: any) => option?.addedQty) || [];
    for (const availableOption of availableAddedOptions) {
      for (const loc of availableOption?.locations) {
        if (availableOption.name === 'Online') {
          for (const location of loc?.locations) {
            if (location.totalAvailable < location.count) {
              location.error = true;
              this.isSaveDisabled = true;
            } else {
              location.error = false;
            }
          }
        } else {
          if (loc.totalAvailable < loc.count) {
            loc.error = true;
            this.isSaveDisabled = true;
          } else {
            loc.error = false;
          }
        }
      }
    }
  }

  handleValidate() {
    this.isSaveDisabled = false;

    for (const supplier of this.tireSupplierDetails) {
      for (const location of supplier?.locations) {
        if (location.totalAvailable < location.count) {
          location.error = true;
          this.isSaveDisabled = true;
        } else {
          location.error = false;
        }
      }
    }
  }

  handleValidateTireHubQTQ() {
    this.isSaveDisabled = false;
    const availableOptions: any[] = this.availableQtyOptions?.filter((option: any) => option?.addedQty) || [];
    for (const option of availableOptions) {
      for (const location of option?.locations) {
        if (location.totalAvailable < location.count) {
          location.error = true;
          this.isSaveDisabled = true;
        } else {
          location.error = false;
        }
      }
    }
  }

  handleValidateTireHub() {
    this.isSaveDisabled = false;

    for (const location of this.locations) {
      if (location.totalAvailable < location.count) {
        location.error = true;
        this.isSaveDisabled = true;
      } else {
        location.error = false;
      }
    }
  }

  handleClose(isSuccess: boolean = false, data: any = {}) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }

  handleSubmit() {
    if (this.isQTQAddOnEnable) {
      this.handleValidateQTQ();

      if (this.isSaveDisabled) return;

      const locations = [];

      this.availableQtyOptions.forEach((option: any) => {
        if (option.locations.length) {
          option.locations.forEach((loc: any) => {
            if (option.name === 'Online') {
              if (loc?.locations?.length) {
                loc.locations.forEach((location: any) => {
                  if (location.count) {
                    locations.push(location);
                  }
                });
              }
            }
          });
        }
      });

      const aLInvTire: any = this.getALInventoryTire();
      this.handleClose(true, { locations, aLInvTire });
    } else {
      this.handleValidate();

      if (this.isSaveDisabled) return;

      const locations = [];

      this.tireSupplierDetails.forEach((supplier: any) => {
        if (supplier?.locations?.length) {
          supplier.locations.forEach((location: any) => {
            if (location.count) {
              locations.push(location);
            }
          });
        }
      });

      this.handleClose(true, { locations });
    }
  }

  handleSubmitTireHub() {
    if (this.isQTQAddOnEnable) {
      this.handleValidateTireHubQTQ();

      if (this.isSaveDisabled) return;

      let locations: any[] = [];
      this.availableQtyOptions.forEach((option: any) => {
        if (option.name === 'Online') {
          locations = [...locations, ...(option?.locations?.filter(({ count }) => count) || [])];
        }
      });

      const aLInvTire: any = this.getALInventoryTire();

      this.handleClose(true, {
        locations: locations,
        aLInvTire,
        category: this.tire?.category || '',
        tireType: this.tire.tireType || '',
        tireconnectFetValue: this.tire?.tireconnectFetValue || '',
        tireconnectFetSource: this.tire?.tireconnectFetSource || '',
        fetValue: this.tire?.fetValue || 0,
        fetValueSource: this.tire?.fetValueSource || '',
      });
    } else {
      this.handleValidateTireHub();

      if (this.isSaveDisabled) return;

      this.handleClose(true, { locations: this.locations.filter(({ count }) => count), category: this.tire?.category || '', tireType: this.tire.tireType || '' });
    }
  }

  getALInventoryTire() {
    const tires: any[] = this.availableQtyOptions.filter((tire: any) => {
      if (tire.addedQty > 0 && ['Local', 'Other'].includes(tire.name)) {
        return true;
      }
    });
    let alInvTire: any = null;
    if (tires?.length) {
      if (tires[0].locations?.length) {
        alInvTire = tires[0].locations[0].inventoryTireData;
        let location = find(alInvTire?.locations, { warehouseId: this.dataService?.warehouse?.warehouseId, stocked: true });
        let stockDetail = find(alInvTire?.stockDetails, { warehouseId: this.dataService?.warehouse?.warehouseId });
        //handle the only other ware house scenario
        if (!stockDetail) {
          stockDetail = find(alInvTire?.stockDetails, (stockTire: any) => stockTire?.countAvailable > 0);
          if (stockDetail && !location) {
            location = find(alInvTire?.locations, { warehouseId: stockDetail?.warehouseId });
          }
        }
        if (!location) {
          location = this.helperService.deepCopy(tires[0].locations[0]);
        }
        let totalAdded: number = 0;
        let totalAvailableQty: number = 0;
        if (location) {
          if (location.inventoryTireData) {
            delete location.inventoryTireData;
          }
          alInvTire.warehouse = location;
        }
        if (stockDetail) {
          if (alInvTire?.costType === 'latestPo') {
            alInvTire.cost = stockDetail?.latestPoCost || alInvTire?.cost || 0;
          } else if (alInvTire?.costType === 'avg') {
            alInvTire.cost = stockDetail?.averageCost || alInvTire?.cost || 0;
          } else if (alInvTire?.costType === 'cost') {
            alInvTire.cost = alInvTire?.cost;
          }
          //alInvTire.cost = stockDetail?.averageCost || alInvTire?.cost;
        }
        tires.forEach((tire: any) => {
          totalAdded += tire.addedQty;
          totalAvailableQty += tire.TotalQty;
        });
        alInvTire.count = totalAdded;
        alInvTire.countAvailable = totalAvailableQty;
        if (alInvTire?.count > alInvTire?.countAvailable) {
          alInvTire.count = alInvTire?.countAvailable;
        }
      }
    }

    return alInvTire;
  }
}
